import BaseModel from 'src/model/base.model';

class CreditLimitModel extends BaseModel {
  public accountNumber: string;
  public companyName: string;
  public email: string;
  public message: string;
  public mobileNumber: string;
  public name: string;
}

export default CreditLimitModel;
